<template>
  <div class="left-chart-1" id="left-chart-1"></div>
</template>

<script>
import { querysbflzb } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart1',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      config: null,
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const container = document.getElementById('left-chart-1')
      this.chart = this.$echarts.init(container)
      const apiData = await querysbflzb(this.date)
      let chartsDatas = []
      apiData.forEach(item => {
        chartsDatas.push({
          value: item.cnt || 0,
          name: item.assets_type || '其他',
        })
      })
      const options = {
        title: {
          text: '设备分类占比',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          formatter: '{b}：{d}%',
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#fff',
            overflow: 'break',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            name: '占比',
            type: 'pie',
            radius: '60%',
            label: {
              formatter: function(data) {
                return data.percent.toFixed(2) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              rotate: true,
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: chartsDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-1 {
  width: 100%;
  height: 37%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;
}
</style>
